import { render, staticRenderFns } from "./definir-valor-Listagem.vue?vue&type=template&id=6435a9d9&scoped=true&"
import script from "./definir-valor-Listagem.vue?vue&type=script&lang=js&"
export * from "./definir-valor-Listagem.vue?vue&type=script&lang=js&"
import style0 from "./definir-valor-Listagem.vue?vue&type=style&index=0&id=6435a9d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6435a9d9",
  null
  
)

export default component.exports